module.exports = __webpack_public_path__ + "img/456.d4c323ac.png";